export const guardianSiblingsRelationships = [
    {value: "father", text: "Father"},
    {value: "mother", text: "Mother"},
    {value: "brother", text: "Brother"},
    {value: "sister", text: "Sister"},
    {value: "grandfather", text: "Grandfather"},
    {value: "grandmother", text: "Grandmother"},
    {value: "uncle", text: "Uncle"},
    {value: "aunt", text: "Aunt"},
    {value: "cousin", text: "Cousin"},
    {value: "legal_guardian", text: "Legal Guardian"},
    {value: "nephew", text: "Nephew"},
    {value: "niece", text: "Niece"},
    {value: "father-in-law", text: "Father-in-law"},
    {value: "mother-in-law", text: "Mother-in-law"},
    {value: "brother-in-law", text: "Brother-in-law"},
    {value: "sister-in-law", text: "Sister-in-law"},
    {value: "stepfather", text: "Stepfather"},
    {value: "stepmother", text: "Stepmother"},
    {value: "other", text: "Other"},
];
